import { NgModule } from '@angular/core';
import { MatButtonModule,
         MatCheckboxModule,
         MatInputModule,
         MatTableModule,
         MatToolbarModule,
         MatIconModule,
         MatListModule,
         MatSidenavModule,
         MatCardModule } from '@angular/material';

@NgModule({
  imports: [ MatButtonModule,
             MatCheckboxModule,
             MatInputModule,
             MatTableModule,
             MatToolbarModule,
             MatIconModule,
             MatListModule,
             MatSidenavModule,
             MatCardModule],
  exports: [ MatButtonModule,
             MatCheckboxModule,
             MatInputModule,
             MatTableModule,
             MatToolbarModule,
             MatIconModule,
             MatListModule,
             MatSidenavModule,
             MatCardModule]
})
export class MaterialModule { }



// WEBPACK FOOTER //
// ./src/app/components/material.module.ts